import TextWithIcon from 'components/TextWithIcon';
import JobLabels from 'components/JobLabels';
import { Link } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { ReactComponent as Arrow } from 'assets/icons/arrow-right.svg';

const JobCard = ({ item }) => {
    const { title, desc, labels, date } = item;
    return (
        <Link to={ROUTES.detailJob} className="job-card">
            <div className="job-card__title">
                <span>{title}</span>
                <Arrow />
            </div>
            <div className="job-card__description opacity-70 body1">{desc}</div>
            <JobLabels data={labels} />
            <TextWithIcon iconName="calendar" text={date} />
        </Link>
    );
};

export default JobCard;
